// src/components/ForgotPassword.js
import React, { useState } from "react";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch("https://senu-app.azurewebsites.net/api/users/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error("Something went wrong. Please try again.");
      }

      // Backend always responds with "If that email exists, a reset link has been sent"
      const data = await response.json();
      console.log("Forgot password response:", data);

      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <h2 className="forgot-title">Reset Your Password</h2>

      {submitted ? (
        <p className="forgot-message">
          If an account with <strong>{email}</strong> exists, a password reset email has been sent.
        </p>
      ) : (
        <form className="forgot-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            className="forgot-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" className="forgot-button" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          {error && <p className="forgot-error">{error}</p>}
        </form>
      )}
    </div>
  );
};

export default ForgotPassword;
